<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @showDetail="showDetail"
      @storeAvailableSaleApi="storeAvailableSaleApi"
      @skuStoreUnsaleableApi="skuStoreUnsaleableApi"
      @skuStoreRestockingApi="skuStoreRestockingApi"
      @skuStoreUnrestockingApi="skuStoreUnrestockingApi"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        :checked-count="checkedCount"
        @query="getData"
        @reset="resetPage"
        @putShelves="putShelvesVisible = true"
        @followSale="followSaleVisible = true"
        @crossSiteSales="crossSiteSalesVisible = true"
        @unsaleable="unsaleable()"
        @availableSale="availableSale()"
        @disableDisplay="disableDisplay()"
        @set-operate="setOperate()"
        @restocking="restocking()"
        @noRestocking="noRestocking()"
        @exportFile="exportFile"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <PutShelves :visible.sync="putShelvesVisible" @reload="reloadList" />
    <FollowSale :visible.sync="followSaleVisible" @reload="reloadList" />
    <CrossSiteSales :visible.sync="crossSiteSalesVisible" @reload="reloadList" />
    <Detail
      :visible.sync="detailVisible"
      :storeCode="storeCode"
      :disabled="disabled"
      :title="title"
      :amzSkuStoreCode="amzSkuStoreCode"
      @reload="reload"
    />
    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
      @export-success="clearCheckList"
    />

    <SetOperate
      :visible.sync="setOperateOptions.visible"
      :listCode="setOperateOptions.listCode"
      @reload="reloadList"
    />
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageHeader from './header'
import PageMain from './main.vue'
import PutShelves from '../put-shelves'
import Detail from '../detail'
import FollowSale from '../follow-sale'
import CrossSiteSales from '../cross-site-sales'
import chooseTemplate from '@/views/ecom/components/choose-template'
import SetOperate from '../set-operate'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    PutShelves,
    FollowSale,
    CrossSiteSales,
    Detail,
    chooseTemplate,
    SetOperate,
  },
  data() {
    return {
      usePage: true,
      checkedRow: [],
      putShelvesVisible: false,
      followSaleVisible: false,
      crossSiteSalesVisible: false,
      detailVisible: false,
      disabled: false,
      title: '',
      storeCode: '',
      amzSkuStoreCode: '',
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'ecom-skuListing',
        searchForm: {},
      },
      setOperateOptions: {
        visible: false,
        listCode: [],
      },
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzSkuListingApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    unsaleable() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_unsaleable') || '请选择需要修改为不可售的SKU',
          type: 'warning',
        })
        return
      }
      const listCode = this.checkedRow.map((item) => item.amzSkuStoreCode)
      this.$confirm(
        this.$l('tips_confirm_unsaleable') ||
          '是否要将选择中的记录修改为不可售',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.skuStoreUnsaleableApi(listCode)
      })
    },

    async skuStoreUnsaleableApi(listCode) {
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzSkuStoreUnsaleableApi({ listCode })
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_update_no') || '修改失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_update_ok') || '修改成功！',
        type: 'success',
      })
      this.clearCheckList()
      this.reload()
    },

    availableSale() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_availableSale') || '请选择需要修改为可售的SKU',
          type: 'warning',
        })
        return
      }
      const listCode = this.checkedRow.map((item) => item.amzSkuStoreCode)
      this.$confirm(
        this.$l('tips_confirm_availableSale') ||
          '是否要将选择中的记录修改为可售',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.storeAvailableSaleApi(listCode)
      })
    },
    async storeAvailableSaleApi(listCode) {
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzSkuStoreAvailableSaleApi({ listCode })
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_update_no') || '修改失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_update_ok') || '修改成功！',
        type: 'success',
      })
      this.clearCheckList()
      this.reload()
    },
    disableDisplay() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_disableDisplay') ||
            '请选择需要修改为禁止显示的SKU',
          type: 'warning',
        })
        return
      }

      const listCode = this.checkedRow.map((item) => item.amzSkuStoreCode)
      this.$confirm(
        this.$l('tips_confirm_disableDisplay') ||
          '是否要将选择中的记录修改为禁止显示',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomAmzSkuStoreDisableDisplayApi({ listCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_update_no') || '修改失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_update_ok') || '修改成功！',
          type: 'success',
        })
        this.clearCheckList()
        this.reload()
      })
    },
    showDetail({ storeCode, amzSkuStoreCode, disabled, title }) {
      this.detailVisible = true
      this.disabled = disabled
      this.title = title
      this.storeCode = storeCode
      this.amzSkuStoreCode = amzSkuStoreCode
    },
    exportFile(form) {
      const checkList =
        this.checkedRow?.map((item) => item?.amzSkuStoreCode || '') || []
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm = form || {}
      this.chooseTemplateOptions.searchForm.checkList = checkList.filter((e) =>
        Boolean(e)
      )
    },
    setOperate() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_setOperate') ||
            '请选择需要更新运营人员的listing',
          type: 'warning',
        })
        return
      }

      const listCode = this.checkedRow.map((item) => item.amzSkuStoreCode)
      this.setOperateOptions = { visible: true, listCode }
    },
    restocking() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_restocking') || '请选择需要修改为可补货的SKU',
          type: 'warning',
        })
        return
      }
      const listCode = this.checkedRow.map((item) => item.amzSkuStoreCode)
      this.$confirm(
        this.$l('tips_confirm_restocking') ||
          '是否要将选择中的记录修改为可补货',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.skuStoreRestockingApi(listCode)
      })
    },

    async skuStoreRestockingApi(listCode) {
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzSkuStoreRestockingApi({ listCode })
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_update_no') || '修改失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_update_ok') || '修改成功！',
        type: 'success',
      })
      this.clearCheckList()
      this.reload()
    },

    noRestocking() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_noRestocking') ||
            '请选择需要修改为不补货的SKU',
          type: 'warning',
        })
        return
      }
      const listCode = this.checkedRow.map((item) => item.amzSkuStoreCode)
      this.$confirm(
        this.$l('tips_confirm_noRestocking') ||
          '是否要将选择中的记录修改为不补货',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.skuStoreUnrestockingApi(listCode)
      })
    },
    async skuStoreUnrestockingApi(listCode) {
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzSkuStoreUnrestockingApi({ listCode })
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_update_no') || '修改失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_update_ok') || '修改成功！',
        type: 'success',
      })
      this.clearCheckList()
      this.reload()
    },
    clearCheckList() {
      this.$refs.main.removeCheckboxRow()
      this.checkedRow = []
    },
    reloadList() {
      this.clearCheckList()
      this.reload()
    },
  },
}
</script>
